import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-waves',
	templateUrl:'./WavesEffectPluginPage.html',
	styles: [],
	styleUrls:['./WavesEffectPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WavesEffectPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_673 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>waveseffect</artifactId>
</dependency>
\`\`\``;
	mdContent_674 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:waveseffect:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_675 = `\`\`\`json
"node-waves": "^0.7.6"
\`\`\``;
	mdContent_676 = `\`\`\`java
var button = new WaButton<>("Click Me");
button.addFeature(new WavesAttachFeature(button));
\`\`\``;
	mdContent_677 = `\`\`\`java
var feature = new WavesApplyToSelectorFeature(".btn",
    WavesEffects.Waves_Light, WavesEffects.Waves_Circle);
page.getBody().addFeature(feature);
\`\`\``;
	mdContent_678 = `\`\`\`java
module com.myapp {
    requires com.jwebmp.plugins.waveseffect;
}
\`\`\``;
	mdContent_679 = `\`\`\`java
// Attach waves to a component
var button = new WaButton<>("Click Me");
button.addFeature(new WavesAttachFeature(button));

// Apply via CSS selector with effect variant
var feature = new WavesApplyToSelectorFeature(".btn",
    WavesEffects.Waves_Light);
page.getBody().addFeature(feature);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
